/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Roleadmin2Inputs */

const zh_organizationsettings_roleadmin2 = /** @type {(inputs: Organizationsettings_Roleadmin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员`)
};

const en_organizationsettings_roleadmin2 = /** @type {(inputs: Organizationsettings_Roleadmin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const es_organizationsettings_roleadmin2 = /** @type {(inputs: Organizationsettings_Roleadmin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Organizationsettings_Roleadmin2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_roleadmin2 = /** @type {((inputs?: Organizationsettings_Roleadmin2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Roleadmin2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_roleadmin2(inputs)
	if (locale === "en") return en_organizationsettings_roleadmin2(inputs)
	return es_organizationsettings_roleadmin2(inputs)
});
export { organizationsettings_roleadmin2 as "organizationSettings_roleAdmin" }